export const STATIC_REALM_ID = `dd180bca-465a-470a-abe4-9d5a15ded551`;
export const STATIC_USER_ID = `1`;
const getHost = () => {
  // Get these urls from url obj and remove this
  // if (env === "prod") {
  //   return "traders.ninjacart.in";
  // }
  return `${process.env.CUSTOM_DOMAIN}`;
};
const workflowURL = `https://${getHost()}/workflow-engine`;
const paths = {
  client_credentials: `https://${process.env.CUSTOM_DOMAIN}/iam/oauth2/token?grant_type=client_credentials`,
  generate_code: `https://${process.env.CUSTOM_DOMAIN}/iam/api/v1/auth/generate/code`,
  tools: () => `https://${process.env.CUSTOM_DOMAIN}/registry/api/v1/Tool`,
  requestOTPUrl: () =>
    `${workflowURL}/${STATIC_REALM_ID}/${STATIC_USER_ID}/v1/execution/service/runWithNoAuth/user-login-otp-notification-service-config`,
  submitOTPUrl: () =>
    `https://${process.env.CUSTOM_DOMAIN}/workflow-engine/${STATIC_REALM_ID}/${STATIC_USER_ID}/v1/execution/service/run/onboard-traders`,
  traderHome: (userId) =>
    `${workflowURL}/${STATIC_REALM_ID}/${userId}/v1/execution/service/run/trader-app-home-screen-v1`,
  wallet: () =>
    `${workflowURL}/${STATIC_REALM_ID}/${STATIC_USER_ID}/v1/execution/service/run/trader-wallet-info`,
  signInCode: () =>
    `https://${process.env.CUSTOM_DOMAIN}/iam/api/v1/auth/signin/code`,
  profile: (userId, realmId) => {
    return `https://${process.env.CUSTOM_DOMAIN}/workflow-engine/${realmId}/${userId}/v1/execution/request`;
  },

  // createVanAccount: (
  //   realmId = `9ed83acf-9dec-4f21-addd-8d171f5427f7`,
  //   userId = `1197791`
  // ) => {
  //   return `https://traders.ninjacart.in/workflow-engine/9ed83acf-9dec-4f21-addd-8d171f5427f7/1197791/v1/execution/request`;
  // },
  generateCode: `https://${process.env.CUSTOM_DOMAIN}/iam/api/v1/auth/generate/code`,
  userInfo: (userId) =>
    `https://${process.env.CUSTOM_DOMAIN}/registry/api/v1/User/${userId}`
};

export default paths;
